module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921001151_T.99276c15.jpg";